import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BulkOperationResult } from '../../Common/Models/bulk-operation-result.model';
import { AppealRecommendationTemplateComponent } from './appealRecommendationTemplate.component';
import { AppealRecommendationRepository } from '../appealRecommendation.repository';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class AppealRecommendationTemplateModalService {
    constructor(
        private modalService: BsModalService,
        private readonly _appealRecommendationRepository: AppealRecommendationRepository,
    ) {}

    modalRef: BsModalRef;

    private _previousTaskIds: number[] | null = null;
    private _availableRecipients: Core.AppealRecipientModel[] | null = null;
    private _inFlightRequest: Promise<Core.AppealRecipientModel[]> | null = null;

    launchModal(taskIds: number[], instanceId: number): Promise<() => void> {
        return new Promise<() => Promise<BulkOperationResult[]>>((resolve, reject) => {
            const initialState = {
                taskIds: taskIds,
                instanceId: instanceId,
                callback: (result: () => Promise<BulkOperationResult[]>) => {
                    resolve(result);
                },
            };

            this.modalRef = this.modalService.show(AppealRecommendationTemplateComponent, {
                initialState,
                class: 'modal-no-max-width modal-xl',
            });
        });
    }

    async getAvailableRecipients(taskIds: number[]): Promise<Core.AppealRecipientModel[]> {
        if (this._previousTaskIds && this._arraysEqual(this._previousTaskIds, taskIds)) {
            if (this._availableRecipients) {
                return this._availableRecipients;
            }
            if (this._inFlightRequest) {
                return this._inFlightRequest;
            }
        }

        this._previousTaskIds = taskIds;
        this._availableRecipients = null;
        this._inFlightRequest = lastValueFrom(
            this._appealRecommendationRepository.getAvailableRecipients(taskIds),
        ).then((result) => {
            this._availableRecipients = result;
            this._inFlightRequest = null;
            return result;
        }).catch((error) => {
            this._inFlightRequest = null;
            this._previousTaskIds = null;
            throw error;
        });

        return this._inFlightRequest;
    }

    private _arraysEqual(arr1: number[], arr2: number[]): boolean {
        if (arr1.length !== arr2.length) {
            return false;
        }
        const sortedArr1 = [...arr1].sort();
        const sortedArr2 = [...arr2].sort();
        return sortedArr1.every((value, index) => value === sortedArr2[index]);
    }
}
